import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import { changePassword, sendCode, bindPhone } from '@/api/user';
import NoticeDialog from '@/views/notice/components/detail.vue';
import { fetchNoticeList } from '@/api/notice';
export default {
  components: {
    Breadcrumb,
    NoticeDialog
  },
  data() {
    const checkConfirmPassword = (rule, value, callback) => {
      if (this.passwordForm.password !== this.passwordForm.password_confirmation) {
        callback(new Error('两次密码码输入不一致'));
      }
      callback();
    };
    const checkPassword = (rule, value, callback) => {
      var pwdRegex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{6,30}');
      if (!pwdRegex.test(value)) {
        callback(new Error('您的密码复杂度太低（密码中必须包含字母、数字）'));
      }
      callback();
    };
    return {
      sendInterval: null,
      sendText: '发送验证码',
      bindPhoneDialogFormVisible: false,
      dialogFormVisible: false,
      codeStatus: 0,
      SendForm: {
        phone: '',
        sms_code: ''
      },
      rulesSendForm: {
        phone: [{
          required: true,
          message: '请填写手机号码',
          trigger: 'blur'
        }],
        sms_code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }]
      },
      passwordForm: {
        current_password: '',
        password: '',
        password_confirmation: ''
      },
      rules: {
        current_password: [{
          required: true,
          message: '请填写原密码',
          trigger: 'blur'
        }],
        password_confirmation: [{
          required: true,
          message: '请再次输入新密码',
          trigger: 'blur'
        }, {
          validator: checkConfirmPassword
        }],
        password: [{
          required: true,
          message: '请填写新密码',
          trigger: 'blur'
        }, {
          validator: checkPassword
        }]
      },
      readNoticeVisible: false,
      newNotice: {}
    };
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device', 'name', 'corporationName', 'user'])
  },
  mounted() {
    this.getNotices();
    if (this.user && this.user.is_change_pwd === false) {
      this.dialogFormVisible = true;
    } else if (this.user && this.user.phone === '') {
      this.bindPhoneDialogFormVisible = true;
    }
  },
  methods: {
    getNotices() {
      fetchNoticeList({
        page: 1,
        limit: 4
      }).then(res => {
        if (res.code === 200 && res.data.items.length) {
          this.newNotice = res.data.items.length && res.data.items[0];
          if (localStorage.getItem('readNotice') !== 'true') {
            this.readNoticeVisible = true;
          }
        }
      });
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    sendCode() {
      if (this.codeStatus !== 0) {
        return;
      }
      if (!this.SendForm.phone) {
        this.$message({
          message: '请输入手机号码',
          type: 'warning'
        });
        return;
      }
      sendCode(this.SendForm.phone, 'admin_bind_phone').then(res => {
        this.$message({
          message: '验证码已发送，请注意查收！',
          type: 'success'
        });
        this.codeStatus = 60;
        clearInterval(this.sendInterval);
        const fun = () => {
          this.sendText = '倒计时' + this.codeStatus + 's';
          this.codeStatus--;
          if (this.codeStatus <= 0) {
            this.codeStatus = 0;
            this.sendText = '重新发送';
          }
        };
        fun();
        this.sendInterval = setInterval(fun, 1000);
      });
    },
    async logout() {
      this.$store.dispatch('user/logout').then(res => {
        this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`);
      });
    },
    handleSubmit() {
      this.$refs['pwForm'].validate(valid => {
        if (valid) {
          changePassword(this.passwordForm).then(() => {
            this.dialogFormVisible = false;
            this.$store.dispatch('user/getInfo');
            this.$notify({
              title: 'Success',
              message: '密码修改成功',
              type: 'success',
              duration: 2000
            });
            this.resetForm('bind');
          });
        }
      });
    },
    SendHandleSubmit() {
      this.$refs['sendForm'].validate(valid => {
        if (valid) {
          bindPhone(this.SendForm).then(() => {
            this.bindPhoneDialogFormVisible = false;
            this.$store.dispatch('user/getInfo');
            this.$notify({
              title: 'Success',
              message: '绑定成功',
              type: 'success',
              duration: 2000
            });
            this.resetSendForm();
          });
        }
      });
    },
    handlePasswordChange() {
      this.dialogFormVisible = true;
    },
    resetForm(flag) {
      this.passwordForm.current_password = '';
      this.passwordForm.password = '';
      this.passwordForm.password_confirmation = '';
      this.$refs.pwForm.resetFields();
      if (this.user && this.user.is_change_pwd === false && flag === 'pwd') {
        this.dialogFormVisible = true;
      } else if (this.user && this.user.phone === '' && flag === 'bind') {
        this.bindPhoneDialogFormVisible = true;
      }
    },
    resetSendForm() {
      this.passwordForm.phone = '';
      this.passwordForm.sms_code = '';
      this.$refs.sendForm.resetFields();
    }
  }
};